import { Component, Input } from '@angular/core';
import { FormArray, FormGroup, NonNullableFormBuilder, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { EditLicenseFormComponent } from '../edit-license-form/edit-license-form.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 't-llevo-edit-licenses-form',
  standalone: true,
  imports: [
    MatExpansionModule,
    EditLicenseFormComponent,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
  ],
  templateUrl: './edit-licenses-form.component.html',
  styles: `
    mat-action-row{
      display: flex;
      justify-content: right;
      width: 100%;
    }

    mat-panel-description{
      display: flex;
      justify-content: right;
    }
  `
})
export class EditLicensesFormComponent {
  @Input({required: true})frm!: FormArray<FormGroup>
  
  protected step = 0;
  constructor(private _fb: NonNullableFormBuilder){}

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  deleteLicense(index: number, event: Event){
    event.stopPropagation()
    this.frm.removeAt(index)
    this.frm.markAsDirty()
    this.prevStep()
  }

  addLicense(event: Event){
    event.stopPropagation()
    this.frm.push(
      this._fb.group({
        categories: this._fb.control<string[]>([], [Validators.required]),
        licenseNumber: ['', [Validators.required, Validators.pattern(/^[a-zA-Z]{1}[0-9]{6}$/)],],
        expeditionDate: ['', Validators.required],
        expiredYear: this._fb.control<number>(new Date().getFullYear(), [Validators.required, Validators.min(new Date().getFullYear()), Validators.max(2050), Validators.pattern(/^[0-9]{4}$/),]),
        image: this._fb.control<File | null>(null, [Validators.required]),
      })
    )
    this.setStep(this.frm.length - 1)
  }
}
